import { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { message } from 'antd';
import useMindMapService from '../../hooks/useMindMapService';
import { emitEdgeAdd, emitEdgeDelete, emitNodeAdd, emitNodeDelete, emitNodeUpdate } from '../../Socket/socket';
import { defaultSizeOf } from '../Shapes/shapeCatalog';
import { saveGraphDiff } from './saveGraphDiff';

const EMIT = {
    nodeAdd: emitNodeAdd,
    nodeUpdate: emitNodeUpdate,
    nodeDelete: emitNodeDelete,
    edgeAdd: emitEdgeAdd,
    edgeDelete: emitEdgeDelete,
};

// Saves and broadcasts an applied change (`diff`, with `snapshot` = the map after it). Used by undo/redo and menus.
const useSaveGraphDiff = () => {
    const { documentId } = useParams();
    const mindMapService = useMindMapService();
    return useCallback((diff, snapshot) =>
        saveGraphDiff({ diff, snapshot, documentId, service: mindMapService, emit: EMIT, defaultSize: defaultSizeOf })
            .catch((error) => {
                message.error('Could not save the change');
                console.error('Saving a map change failed:', error);
            }),
    [documentId, mindMapService]);
};

export default useSaveGraphDiff;
